module.exports = __webpack_public_path__ + "img/box_press_buttons.0e03a2a3.svg";